import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";

//Types
import { SvgIconProps } from "@mui/material";

function POIIcon(props: SvgIconProps) {
  return <LocationOnIcon {...props}/>;
}

export default POIIcon;
